module.exports = __webpack_public_path__ + "media/images/logo_visa-9ea4205242377271f068227f46753d35.png";